/**
 * Created by zhengyf on 2018/4/8.
 */

/**
 * 底稿功能
 * 存在本地的底稿没有 uid 前缀，导致在同一台电脑，后面的用户会使用前面用户的底稿
 */

;(function () {

    DataRecoverService.$inject = ['request', '$interval', '$timeout', '$q'];
    angular
        .module('app.core')
        .service('DataRecoverService', DataRecoverService);

    function DataRecoverService(request, $interval, $timeout, $q) {

        var util = DSSX.util;

        /**
         * 底稿类型
         */
        var SketchType = {
            Product: 'product', // 产品发布
            Trusts: 'credit_order', // 信保订单
            Rfq: 'quotation', // rfq
            Company: 'company_info', // 公司信息
            AuthInfo: 'auth_info', // 认证信息
            Exam: 'exam', // 考试
        };

        // 相同类型的底稿对应的前缀
        var SketchTypeLSKeyPrefix = {
            Product: 'sketch_product_',
            Trusts: 'sketch_trusts_',
            Rfq: 'sketch_rfq_',
            Company: 'sketch_company_',
            AuthInfo: 'sketch_auth_info_',
            Exam: 'sketch_exam_'
        };

        var sketch = {
            id: ''
        };

        var store = {
            lsNewData: null,
            lsOldData: null,
            serverNewData: null,
            serverOldData: null,
            stopSaveLS: null,
            stopSaveServer: null
        };

        /**
         * 启动底稿功能
         * @params {string} sketchType 底稿类型
         * @params {function} getData 获取底稿数据的函数
         * @params {string} dataId 实例ID
         * @params {object} options isShareSketch: false, time: {ls: 5000, serverFirst: 5000, serverNormal: 20000}
         * @params {object} otherInfo {rfqId: ''} 这个参数是因为rfq固定了6个类型 这个参数用作类型下面的子类型判断
         */
        this.start = function (sketchType, getData, dataId, options, otherInfo) {

            // 预览模式停止底稿功能
            if (DSSX.attr.isPreviewMode) {
                return;
            }

            options = options || {
                ls: {},
                server: {}
            }

            // todo 参数校验

            saveDataToLS(sketchType, getData, dataId, options.ls, otherInfo);
            saveDataToServer(sketchType, getData, options.server, otherInfo);

        }

        /**
         * 获取最新底稿
         * @params {string} sketchType 底稿类型
         * @params {string} dataId 底稿Id
         * @params {object} otherInfo {rfqId: ''} 这个参数是因为rfq固定了6个类型 这个参数用作类型下面的子类型判断
         * @return {*} lastSketch 最新的底稿数据
         */
        this.getLastSketch = function (sketchType, dataId, otherInfo) {

            var type = getSketchType(sketchType),
                lsKeyPrefix = getSketchTypeLSKeyPrefix(sketchType),
                lsKeys,
                lsData,
                lsLastSketch,
                serverSketch,
                lastSketch,
                params
            ;

            // 没有id 代表新添加的数据
            if (!dataId) {
                // 新产品数据

                if (sketchType === 'Rfq') {
                    lsKeyPrefix = lsKeyPrefix + otherInfo.rfqId + '_';
                }

                lsKeys = getTargetLSKeys(lsKeyPrefix);
                lsData = getTargetLSValues(lsKeys);
                lsLastSketch = getLastSketchFromLS(lsData, true); // 本地最新的数据

                // todo 未考虑http请求错误的状态 可能会把已编辑的产品的底稿删除导致获取服务器的底稿不是最新的底稿
                // 直接清除1小时以前的ls
                var preDelKeys = findBeforeOneHourSketch(lsLastSketch, lsKeys);
                removeSketchFromLS(preDelKeys);

                params = {
                    id: lsLastSketch.id || '',
                    type: type
                };

            } else {
                lsKeys = [lsKeyPrefix + dataId];
                lsData = getTargetLSValues(lsKeys);
                lsLastSketch = getLastSketchFromLS(lsData);

                params = {
                    id: dataId
                };
            }

            if (sketchType === 'Rfq') {
                params.typeCase = otherInfo.rfqId; // 这里是rfqId
            }

            // 获取服务器的最新底稿
            return getSketchFromServer(params)
                .then(handlerSketch);

            function handlerSketch(data) {
                serverSketch = data;

                // 预览模式停止底稿功能
                if (DSSX.attr.isPreviewMode) {
                    return null;
                }

                // 不存在底稿数据
                if (!serverSketch.id) {
                    return null;
                }

                // 本地底稿数据不存在， 服务器底稿数据存在
                if (!lsLastSketch.id && serverSketch.id) {
                    return serverSketch;
                }

                // 如果本地和服务器底稿数据都存在
                if (lsLastSketch.id && serverSketch.id) {
                    lastSketch = serverSketch.version >= lsLastSketch.data.version ? serverSketch : lsLastSketch;
                }

                return lastSketch;
            }

        }

        // 获得sketch.id
        this.getSketchId = function () {
            return sketch.id;
        }

        /**
         * 更新sketch
         * @param arg_sketch 底稿相关所有数据
         * @param sketchId 底稿id
         */
        this.updateSketch = function (arg_sketch, sketchId) {

            if (!arg_sketch) {
                sketch.id = sketchId;
            } else {
                sketch = arg_sketch;
            }
        }

        /**
         * 删除底稿
         * @param sketchType 底稿类型
         * @param id 底稿id
         * @param rfqId rfqId （rfq模块才需要）
         */
        this.deleteSketch = function (sketchType, id, rfqId) {
            var type = getSketchType(sketchType),
                lsKeyPrefix = getSketchTypeLSKeyPrefix(sketchType)
            ;

            if (sketchType === 'Rfq') {
                lsKeyPrefix = lsKeyPrefix + rfqId + '_';
            }

            // 删除本地的底稿
            localStorage.removeItem(lsKeyPrefix + id);

            // 删除服务器上的底稿
            return request.post('/usr/api/updateSketch', {commit: 1}, {
                id: id,
                type: type
            }).then(function () {
                console.log('[DataRecover] 删除底稿成功');
            }, function (error) {
                console.log('[DataRecover] 删除底稿失败');
                return $q.reject(error)
            })
        }

        // 获得 停止循环的标记
        this.getStopSaveFlag = function () {
            return {
                stopSaveLS: store.stopSaveLS,
                stopSaveServer: store.stopSaveServer
            };
        }

        /**
         * 每隔一定时间将数据存储在localStorage 这里要看是否共享底稿
         * @params {string} sketchType 底稿类型
         * @params {function} getData 获取底稿数据的函数
         * @params {object} initData 初始值
         * @params {object} options isShareSketch: false, time: 5000
         * @params {object} otherInfo {rfqId: ''} 这个参数是因为rfq固定了6个类型 这个参数用作类型下面的子类型判断
         */
        function saveDataToLS(sketchType, getData, dataId, options, otherInfo) {
            // todo 参数校验

            options = options || {};
            options.isShareSketch = !!options.isShareSketch;
            options.time = options.time || 5000;

            sketch.id = dataId;
            store.lsOldData = angular.copy(getData()); // 初始值

            store.stopSaveLS = $interval(function () {
                if (!sketch.id) {
                    return;
                }

                store.lsNewData = angular.copy(getData());

                // 判断数据是否和 oldData 一致
                if (isEqual(store.lsNewData, store.lsOldData)) {
                    return;
                }

                var lsKeyPrefix = getSketchTypeLSKeyPrefix(sketchType);
                var lsKey = lsKeyPrefix + sketch.id;

                // todo 可能有问题
                // 共享底稿 需要清除之前存储的localStorage
                if (options.isShareSketch) {
                    var keys = getTargetLSKeys(lsKeyPrefix);
                    removeSketchFromLS(keys);
                }

                var version = sketch.version ? sketch.version + 1 : 1;

                // todo 临时解决办法 复用新产品sketchId时,第一次存本地没有复用其他信息导致新产品sketch.isNew是undefined
                var isNewProd = false;
                if (!dataId || (dataId && !options.isShareSketch && dataId.indexOf('SK') === 0)) {
                    isNewProd = true;
                }

                var data = {
                    data: store.lsNewData,
                    version: version,
                    isNewProd: isNewProd,
                    last: util.getServerCurrentTime().getTime()
                };

                if (sketchType === 'Rfq') {
                    data.rfqId = otherInfo.rfqId;
                    lsKey = lsKeyPrefix + otherInfo.rfqId + '_' + sketch.id;
                }

                var sketchData = angular.extend({}, sketch, {data: data});

                window.localStorage[lsKey] = JSON.stringify(sketchData);

                store.lsOldData = store.lsNewData;

            }, options.time);
        }

        /**
         * 每隔一定时间将数据存储在服务器
         * @params {string} sketchType 底稿类型
         * @params {function} getData 获取数据函数
         * @params {object} options 时间间隔 默认5000ms 20000ms
         * @params {object} otherInfo {rfqId: ''} 这个参数是因为rfq固定了6个类型 这个参数用作类型下面的子类型判断
         */
        function saveDataToServer(sketchType, getData, options, otherInfo) {

            // todo 参数校验
            var time = options.time || {};
            time.first = time.first || 5000;
            time.normal = time.normal|| 20000;

            sketchType = getSketchType(sketchType);
            store.serverOldData = angular.copy(getData());

            if (!sketch.id) {
                var stop = saveToServer(time.first);
                $timeout(function () {
                    $interval.cancel(stop);
                    saveToServer(time.normal);
                }, time.first);
            } else {
                store.stopSaveServer = saveToServer(time.normal);
            }

            function saveToServer(arg_time) {
                return $interval(function () {

                    store.serverNewData = angular.copy(getData());

                    // 判断数据是否和 oldData 一致
                    if (isEqual(store.serverNewData, store.serverOldData)) {
                        return;
                    }

                    var sketchData = {
                        data: {
                            data: store.serverNewData
                        },
                        id: sketch.id,
                        type: sketchType
                    };

                    if (sketchType === 'quotation') {
                        sketchData.typeCase = otherInfo.rfqId; // rfq id
                    }

                    save(sketchData)
                        .then(function (d_sketch) {
                            sketch = d_sketch;
                            store.serverOldData = store.serverNewData;
                        });
                }, arg_time);
            }

            function save(arg_data) {
                return request.post('/usr/api/updateSketch', {}, arg_data, true)
                    .then(callback, errCallback);

                function callback(res) {
                    return util.safe(res, 'data.sketch', {});
                }

                // http 请求失败 返回之前的数据
                function errCallback(err) {
                    console.log('[DataRecover] saveDataToServer 保存底稿数据到服务器失败: ', err);
                    return sketch || {};
                }
            }

        }

        // 获取底稿类型
        function getSketchType(sketchType) {
            return SketchType[sketchType];
        }

        // 根据底稿类型获得对应的存储在本地的key前缀
        function getSketchTypeLSKeyPrefix(sketchType) {
            return SketchTypeLSKeyPrefix[sketchType] + DSSX.uinfo.uid + '_';
        }

        // 根据传入的前缀，获取对应前缀的所有key值
        function getTargetLSKeys(keyPrefix) {
            var keys = [],
                lsLength = localStorage.length,
                reg = new RegExp('^' + keyPrefix)
            ;
            for (var i = 0; i < lsLength; i++) {
                var key = localStorage.key(i);

                if (reg.test(key)) {
                    keys.push(key);
                }
            }
            return keys;
        }

        // 根据key值获得value
        function getTargetLSValues(keys) {
            return keys.map(function (key) {
                return getSingleLSValue(key);
            })
        }

        // 根据一个key获得对应value
        function getSingleLSValue(key) {
            var data;
            try {
                data = JSON.parse(window.localStorage[key] || {});
            } catch (error) {
                console.log('[dataRecover] getTargetLSValues JSON.parse', error);
                data = {};
            }
            return data;
        }

        // 根据key值移除本地存储
        function removeSketchFromLS(keys) {
            keys.forEach(function (key) {
                localStorage.removeItem(key);
            })
        }

        /**
         * 找出本地最新的底稿
         * @param sketchList 底稿数组
         * @param isNewProd 是否是新产品
         * @returns {object}
         */
        function getLastSketchFromLS(sketchList, isNewProd) {

            isNewProd = !!isNewProd;

            // 已发布的产品底稿
            if (!isNewProd) {
                return sketchList[0]; // 空数组则返回 {}
            }

            // 新产品底稿
            var newSketchList = [];
            sketchList.forEach(function (sketch) {
                sketch.data = sketch.data || {};
                if (sketch.data.isNewProd) {
                    newSketchList.push(sketch);
                }
            });

            if (newSketchList.length < 1) {
                return {};
            }

            if (newSketchList.length === 1) {
                return newSketchList[0];
            }

            var sortSketchList = newSketchList.sort(compare('last'));

            return sortSketchList[sortSketchList.length - 1];

            function compare(property) {
                return function (obj1, obj2) {
                    var value1 = obj1[property];
                    var value2 = obj2[property];
                    return value1 - value2;     // 升序
                }
            }
        }

        // 从服务器获取底稿
        function getSketchFromServer(params) {
            return request.get('/usr/api/loadSketch', params, true)
                .then(callback, errCallback);

            function callback(res) {
                return util.safe(res, 'data.sketch', {});
            }

            function errCallback(err) {
                console.log('[DataRecover] getSketchFromServer 从服务器获取数据失败: ', err);
                return {};
            }
        }

        // 根据最新底稿找出一小时之前的底稿
        function findBeforeOneHourSketch(lastSketch, lsKeys) {

            if (!lastSketch.data) {
                return [];
            }

            var allowTime = lastSketch.data.last - 60 * 60 * 1000;
            var keyList = [];
            lsKeys.forEach(function (key) {
                var data = getSingleLSValue(key);

                if (data.data.last) {
                    if (data.data.last <= allowTime) {
                        keyList.push(key);
                    }
                }
            });

            return keyList;
        }

        // 找出是新增表单的底稿
        function findNewFormKeys(sketchType) {
            var prefix = getSketchTypeLSKeyPrefix(sketchType);
            var keys = getTargetLSKeys(prefix);

            var list = [];
            keys.forEach(function (key) {
                var data = getSingleLSValue(key);

                if (data.isNewProd) {
                    list.push(key);
                }
            })
            return keys;
        }

        this.delAllNewFormSketch = function (sketchType) {
            var keys = findNewFormKeys(sketchType);
            removeSketchFromLS(keys);
        }

        // angular.equals()
        function isEqual(obj1, obj2) {

            var str1 = JSON.stringify(obj1);
            var str2 = JSON.stringify(obj2);

            if (str1 === str2) {
                return true;
            }

            return false;
        }


    }

})();

